import { useState, useEffect, useRef } from "react";
import { authFetch } from "../../App";
import { API } from "./helpers";

export function InlineVerantwortlicher({ value, contactId, users, onChanged }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const ref = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const toggle = (e) => {
    e.stopPropagation();
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 2, left: rect.left });
    }
    setOpen(!open);
  };

  const select = async (name) => {
    setOpen(false);
    if (name === value) return;
    await authFetch(`${API}/crm/contacts/${contactId}`, {
      method: "PUT", body: JSON.stringify({ verantwortlicher: name }),
    });
    onChanged();
  };

  return (
    <>
      <span
        ref={triggerRef}
        className="text-[11px] text-gray-700 cursor-pointer hover:text-blue-600 hover:underline"
        onClick={toggle}
        data-testid={`verantwortlicher-badge-${contactId}`}
      >
        {value || "—"}
      </span>
      {open && (
        <div
          ref={ref}
          className="fixed z-[9999] bg-white border border-gray-200 rounded shadow-lg py-0.5 min-w-[130px] max-h-[200px] overflow-y-auto"
          style={{ top: pos.top, left: pos.left }}
          data-testid={`verantwortlicher-dropdown-${contactId}`}
        >
          {users.length === 0 ? (
            <div className="px-2.5 py-1.5 text-[11px] text-gray-400">Keine Benutzer</div>
          ) : (
            users.map((u) => (
              <div
                key={u.id}
                className={`px-2.5 py-1 text-[11px] cursor-pointer hover:bg-gray-50 ${u.name === value ? "font-semibold text-blue-600" : "text-gray-700"}`}
                onClick={(e) => { e.stopPropagation(); select(u.name); }}
                data-testid={`verantwortlicher-option-${u.name}`}
              >
                {u.name}
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
}
